// extracted by mini-css-extract-plugin
export default {"dock":"Dock_dock__ea18T"};